const REAR_CAMERA_PATTERN =
    /\b(back|rear|environment|traseir[ao]?|trasera|arrière|rück|后置|背面)\b/i;
const FRONT_CAMERA_PATTERN =
    /\b(front|user|frontal|selfie|avant|delantera|前置)\b/i;
const PRIMARY_CAMERA_PATTERN =
    /\b(main|primary|principal|wide|grande[- ]angular|standard|padr[aã]o)\b/i;
const AUXILIARY_CAMERA_PATTERN =
    /\b(ultra[- ]?wide|tele(photo)?|macro|depth|tof|infrared|ir|monochrome)\b/i;

export function inferFacingFromLabel(label = '') {
    if (REAR_CAMERA_PATTERN.test(label)) {
        return 'environment';
    }

    if (FRONT_CAMERA_PATTERN.test(label)) {
        return 'user';
    }

    return 'unknown';
}

function cameraPriority(camera) {
    const labelFacing = inferFacingFromLabel(camera.label);

    return [
        camera.preferred ? 1 : 0,
        labelFacing === 'environment' ? 1 : 0,
        (
            camera.facingMode === 'environment'
            || labelFacing === 'environment'
        ) ? 1 : 0,
        (
            camera.facingMode !== 'user'
            && labelFacing !== 'user'
        ) ? 1 : 0,
        PRIMARY_CAMERA_PATTERN.test(camera.label) ? 1 : 0,
        AUXILIARY_CAMERA_PATTERN.test(camera.label) ? 0 : 1,
        camera.maxPixels || 0,
    ];
}

export function rankCameras(cameras) {
    return [...cameras].sort((left, right) => {
        const leftPriority = cameraPriority(left);
        const rightPriority = cameraPriority(right);

        for (let index = 0; index < leftPriority.length; index++) {
            if (leftPriority[index] !== rightPriority[index]) {
                return rightPriority[index] - leftPriority[index];
            }
        }

        return left.index - right.index;
    });
}
